module.exports = __webpack_public_path__ + "static/media/hamburger_icon_light.b8274cc6.svg";